import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { Outlet, useLocation } from "react-router-dom";
import { toggleSidebar } from '../Redux/slices/ui';
import { useAppSelector } from '../Redux/store';
import Sidebar from "./Sidebar";
import Breadcrumb from './breadCrumb/breadCrumb';

const DashboardLayout = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 850);

  const isSidebarCollapsed = useAppSelector(
    (state) => state.ui.isSidebarCollapsed
  );

  const handleSidebarToggle = () => {
    dispatch(toggleSidebar());
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 850);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isDesktop && isSidebarCollapsed === true) {
      handleSidebarToggle();
    }
  }, [isDesktop, isSidebarCollapsed]);

  return (
    <div className="h-screen w-screen flex bg-gray-100 overflow-hidden">

      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">

        <div className="flex-shrink-0 bg-white border-b border-gray-200">
          <Breadcrumb />
        </div>

        <div className="flex-1 bg-gray-100 overflow-y-auto">
          <div className="px-6 py-4 h-full">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;